import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { Observable } from 'rxjs';


import { IObjectToArrayWithFieldsKeyAndValue, ObjectUtils } from '../utils/object.utils';

import { ProxyConfig, ProxyConfigItem } from './proxy-config-item';

@Injectable({providedIn: 'root'})
export class DevToolsService {

	public targetList: Array<ProxyConfigItem>;

	private storrageKey = 'applicationApiSegments';
	private _applicationApiSegments: ProxyConfigItem | undefined;

	constructor(
		private http: HttpClient,
	) {
	}

	public get applicationApiSegment(): ProxyConfigItem | undefined {
		if (!this._applicationApiSegments) {
			this._applicationApiSegments = this.restoreApplicationApiSegment();
		}
		return this._applicationApiSegments;
	}
	public set applicationApiSegment(segments: ProxyConfigItem | undefined) {
		this._applicationApiSegments = segments;
		this.storApplicationApiSegment(this._applicationApiSegments);
	}


	public getConfig(): Observable<Array<ProxyConfigItem>> {

		return this.http.get('assets/temp/proxy.conf.json')
			.pipe(
				map((x: ProxyConfig) => {

					const array = ObjectUtils.objectToArrayWithFieldsKeyAndValue(x)
						.map((item: IObjectToArrayWithFieldsKeyAndValue<ProxyConfig>) => {
							return {
								segmentName: item.propertyName.replace('/', ''),
								value: item.propertyValue,
							}
						});

					return array;
				}),
			);
	}

	public getRestSegment(url: string): string {
		return this.replaceSegmentInUrl(url, this.applicationApiSegment);
	}


	private restoreApplicationApiSegment(): ProxyConfigItem | undefined {
		const storrageValue = localStorage.getItem(this.storrageKey);
		if (storrageValue) {
			return JSON.parse(storrageValue);
		}

		return undefined;
	}

	private storApplicationApiSegment(segments: ProxyConfigItem | undefined) {
		localStorage.setItem(this.storrageKey, JSON.stringify(segments));
	}

	private replaceSegmentInUrl(url: string, segment: ProxyConfigItem | undefined): string {
		if (segment) {
			url = url.replace(/^rest/, segment.segmentName);
		}
		return url;
	}

}
